<template>
    <div>




        <nav class="level is-mobile">
            <div class="level-left">
                <div class="level-item"  >

                    <b-field label="No." >
                        <p class="control">
                            <span class="button is-static is-medium "  >{{index}}.</span>
                        </p>
                    </b-field>
                </div>
                
                <div class="level-item" >

                    <b-field label="Organism name" style="width: 100%">
                        <b-select placeholder="Select a name Organism"   size="is-medium" v-model="data_orga.idbact">
                            <option
                                    v-for="bactDat in mstOrgaDat"
                                    :value="bactDat.id"
                                    :key="bactDat.id">
                                {{ bactDat.name }}
                            </option>
                        </b-select>
                        <p class="control">
                            <b-button type="is-danger" size="is-medium" outlined icon-right="close"   @click="clearContent('','idbact')"></b-button>
                        </p>
                        <p class="control">
                            <b-button type="is-success" size="is-medium" outlined icon-right="magnify"   @click="selectBact"></b-button>
                        </p>
                    </b-field>
                </div>

                <div class="level-item"  style="width: 100%"  >
                    <b-field   label="Remark" style="width: 100%">
                        <template slot="label">
                            Remark <span :class=" [ data_orga.bact_remark && data_orga.bact_remark.length>GLOBAL_VAR.MAX_CHAR_BACT_REMARK ?`has-text-danger` : `has-text-primary` , `is-italic`] "
                                        v-if="data_orga.bact_remark && data_orga.bact_remark.length>0">
                                                     ({{data_orga.bact_remark.length}}/{{GLOBAL_VAR.MAX_CHAR_BACT_REMARK}})
                                              </span>
                        </template>
                        <b-input v-model="data_orga.bact_remark" style="width: 100%"   size="is-medium"></b-input>
                        <p class="control">
                            <b-button type="is-danger" size="is-medium" outlined icon-right="close"   @click="clearContent('','bact_remark')"></b-button>
                        </p>
                    </b-field>
                </div>




            </div>
            <div class="level-right">

                <div class="level-item">

                    <b-button type="is-danger is-light"
                              icon-right="close"
                              @click="deleteEachBactID"
                              :disabled="!enable"
                    />
                </div>
            </div>
        </nav>

        <hr>

        <nav class="level is-mobile">
            <div class="level-left">
                <div class="level-item">
                    <p style="padding-left: 3.8em "></p>
                </div>
                <div class="level-item">

                    <b-field label="Method" style="width: 100%">
                        <b-select placeholder="Select a Method"   size="is-medium" v-model="data_orga.id_lab_method">
                            <option
                                    v-for="method in mstMethod"
                                    :value="method.id"
                                    :key="method.id">
                                {{ method.name }}
                            </option>
                        </b-select>

                        <p class="control">
                            <b-button type="is-danger" size="is-medium" outlined icon-right="close"   @click="clearMethod"></b-button>
                        </p>
                    </b-field>


                </div>


                <div class="level-item" v-if="data_orga.id_lab_method">

                    <b-field label="Value" style="width: 100%">
                        <b-select placeholder="Select a name Bacterial"   size="is-medium" v-model="data_orga.id_lab_method_result">
                            <option
                                    v-for="result in filterOfResultMethodLab(data_orga.id_lab_method)"
                                    :value="result.id"
                                    :key="result.id">
                                {{ result.data }}
                            </option>
                        </b-select>
                        <p class="control">
                            <b-button type="is-danger" size="is-medium" outlined icon-right="close"   @click="clearMethodResult"></b-button>
                        </p>
                    </b-field>
                </div>


                <div class="level-item" v-if="data_orga.id_lab_method_result">

                    <b-field   label="Remark"  style="width: 100%">
                        <template slot="label">
                            Remark <span :class=" [ data_orga.remark_method && data_orga.remark_method.length>GLOBAL_VAR.MAX_CHAR_BACT_METHOD ?`has-text-danger` : `has-text-primary` , `is-italic`] "
                                         v-if="data_orga.remark_method && data_orga.remark_method.length>0">
                                                     ({{data_orga.remark_method.length}}/{{GLOBAL_VAR.MAX_CHAR_BACT_METHOD}})
                                              </span>
                        </template>
                        <b-input v-model="data_orga.remark_method" style="width: 100%"   size="is-medium" ></b-input>
                        <p class="control">
                            <b-button type="is-danger" size="is-medium" outlined icon-right="close"  @click="clearRemarkMethod"></b-button>
                        </p>
                    </b-field>
                </div>



            </div>

        </nav>


        <hr>

        <b-checkbox v-model="data_orga.want_data_drugs" @input="loadEmplyDrugFromTemplateIntoObj">
           <p class="has-text-grey">{{ cbTxtIncludeOrExcludeDrug }}</p>
        </b-checkbox>
        <b-table
                v-if="data_orga.want_data_drugs"
                :data="data_orga.drugs"
                :bordered=false
                :striped=false
                narrowed



                :hoverable=false
                :focusable=false
                mobile-cards>

            <b-table-column   label="No"  v-slot="props"  >

                {{props.index +1 }}.

            </b-table-column>

            <b-table-column   label="Drug"   >
                <template  v-slot:header="{ column }">
                    {{column.label}}
                        <b-button size="is-small"
                                  type="is-success is-light"
                                  @click="addDrugInEachIDbact_uuid"
                                  icon-left="plus">
                            Add
                        </b-button>
                </template>
                <template v-slot="props">
                    <h3 class="subtitle is-5"> {{ props.row.drug_name }}</h3>
                </template>


            </b-table-column>

            <b-table-column   label="MIC"    v-slot="props">

                <b-field>
                    <p class="control">
                        <b-select    v-model="props.row.idmic_prefix" >
                            <option
                                    v-for="micDat in mstMicDat"
                                    :value="micDat.id"
                                    :key="micDat.id">
                                {{ micDat.name }}
                            </option>
                        </b-select>
                    </p>
                    <b-input v-model="props.row.mic_val" ></b-input>
                    <p class="control">
                        <b-button type="is-danger" outlined icon-right="close"   @click="clearContent(props.row.iddrug,'mic')"></b-button>
                    </p>
                </b-field>
            </b-table-column>


            <b-table-column   label="Result"    >
                <template v-slot:header="{ column }">
                    {{ column.label }}
                    <span class="has-text-danger">*</span>


                    <b-dropdown aria-role="list"    >
                        <template #trigger>
                            <p
                                    class="tag is-success is-light"
                                    role="button">
                                All
                            </p>
                        </template>


                        <b-dropdown-item value="1" @click="setAllResult('1')" aria-role="listitem">R</b-dropdown-item>
                        <b-dropdown-item value="2" @click="setAllResult('2')" aria-role="listitem">I</b-dropdown-item>
                        <b-dropdown-item value="3" @click="setAllResult('3')"  aria-role="listitem">S</b-dropdown-item>
                        <b-dropdown-item value=null @click="setAllResult(null)" aria-role="listitem">clear all</b-dropdown-item>

                    </b-dropdown>


                </template>
                <template v-slot="props">
                    <b-field >
                    <p class="control">
                    <b-select placeholder="R/I/S"  v-model="props.row.idresult" >
                        <option
                                v-for="resultDat in mstResultDat"
                                :value="resultDat.id"
                                :key="resultDat.id">
                            {{ resultDat.name }}
                        </option>
                    </b-select>
                    </p>
                    <p class="control">
                        <b-button type="is-danger"  icon-right="close"   @click="clearContent(props.row.iddrug,'result')" ></b-button>
                    </p>
                    </b-field>
                </template>


            </b-table-column>


            <b-table-column   label="Remark"   v-slot="props" >

                <b-field  :type="{ 'is-danger':   props.row.remark.length>GLOBAL_VAR.MAX_CHAR_BACT_REMARK_EACH  }"
                          :message= "{ 'Max Over range' :   props.row.remark.length>GLOBAL_VAR.MAX_CHAR_BACT_REMARK_EACH   }"  expanded>
                    <b-input v-model="props.row.remark"

                    >{{ props.row.remark }} </b-input>
                    <template slot="message">
                        <span class="has-text-primary is-italic" v-if="props.row.remark">({{props.row.remark.length}}/{{GLOBAL_VAR.MAX_CHAR_BACT_REMARK_EACH}})</span>
                    </template>
                </b-field>

            </b-table-column>

            <b-table-column   label="#"   v-slot="props" >
                <b-button type="is-danger"
                          icon-left="delete"

                          @click="deleteDrugItem( props.row.iddrug_uuid)"
                          :disabled="!enable"
                          >
                    Delete
                </b-button>
            </b-table-column>



        </b-table>
        <SelectDrugOrga
            v-if="isShowSelectDrug"
            :isShowing = isShowSelectDrug
            :drugExisting = data_orga.drugs
            @closeSelectDrug = "closeSelectDrug"
            @closeSelectDrugWithData = "closeSelectDrugWithData"
        />


        <SelectOrga
                v-if="isShowSelectBact"
                :isShowing = isShowSelectBact
                @closeSelectBact = "closeSelectBact"
                @closeSelectBactWithPickData = "closeSelectBactWithPickData"

        />




    </div>
</template>

<script>
    import {mapState} from "vuex";
    import {  MAX_CHAR_BACT_REMARK_EACH , MAX_CHAR_BACT_REMARK , MAX_CHAR_BACT_METHOD , genUUID}  from '@/utils.js'
    import SelectDrugOrga from "./SelectDrugOrga";
    import SelectOrga from "./SelectOrga";


    export default {
        name: "Each_Orga",
        components:{
            SelectDrugOrga,
            SelectOrga
        },
        mounted() {
            // this.bacterialModel = this.data_orga.idbact
        },
        props:{
            enable : Boolean,
            index : Number,
            data_orga : Object  //     example data
                                //        {
                                //         "idbact_uuid": "763eee4bdabe",
                                //         "idbact": 1,
                                //         "name_bact": "Beta staphylococcus intermedius group3+",
                                //         "bact_remark" : "",
                                //         "drugs": [
                                //         {
                                //             "iddrug": 2,
                                //             "drug_name": "Azithromycin",
                                //             "idresult": 1,
                                //             "result_name": "R",
                                //             "idmic_prefix": 1,
                                //             "mic_prefix": ">=",
                                //             "mic_val": "64",
                                //             "remark": null
                                //         },
                                //         {
                                //             "iddrug": 1,
                                //             "drug_name": "Cephalexin",
                                //             "idresult": 1,
                                //             "result_name": "R",
                                //             "idmic_prefix": null,
                                //             "mic_prefix": null,
                                //             "mic_val": null,
                                //             "remark": null
                                //         },
                                //         {
                                //             "iddrug": 4,
                                //             "drug_name": "Enrofloxacin",
                                //             "idresult": null,
                                //             "result_name": null,
                                //             "idmic_prefix": null,
                                //             "mic_prefix": null,
                                //             "mic_val": null,
                                //             "remark": null
                                //         },
                                //         {
                                //             "iddrug": 3,
                                //             "drug_name": "Marbofloxacin",
                                //             "idresult": 3,
                                //             "result_name": "S",
                                //             "idmic_prefix": null,
                                //             "mic_prefix": null,
                                //             "mic_val": null,
                                //             "remark": null
                                //         }
                                //     ]
                                // }
        },
        computed: {
            ...mapState({
                mstMicDat: state => state.orga.mstMicDat,
                mstOrgaDat: state => state.orga.mstOrgaDat,
                mstResultDat: state => state.orga.mstResultDat,

                mstMethod: state => state.orga.mstMethod,
                mstMethodResult : state => state.orga.mstMethodResult,

                dataORGASpecLN : state => state.orga.dataORGASpecLN,
                tmplateOrga : state => state.orga.tmplateOrga,

            }),
            GLOBAL_VAR(){
                return { MAX_CHAR_BACT_REMARK_EACH , MAX_CHAR_BACT_REMARK , MAX_CHAR_BACT_METHOD }
            },

            cbTxtIncludeOrExcludeDrug : function(){
                return this.data_orga.want_data_drugs ? "Include Drugs" : "Exclude Drugs"
            }
        },
        methods:{  /* eslint-disable */

            loadEmplyDrugFromTemplateIntoObj(){
                if (this.data_orga.drugs.length === 0){
                    this.data_orga.drugs =  JSON.parse(JSON.stringify(this.tmplateOrga.drugs))
                }
            },

            setAllResult(_dat){

                this.data_orga.drugs.forEach(dat=>{
                        dat.idresult = _dat
                })


            },
            clearMethod(){
                this.data_orga.id_lab_method  = ""
            }  ,
            clearMethodResult(){
                this.data_orga.id_lab_method_result = ""
            }   ,
            clearRemarkMethod(){
                this.data_orga.remark_method = ""
            }    ,
            filterOfResultMethodLab(idMethod) {
                const tmp =  this.mstMethodResult.find(dat=>{
                    return dat.id_methodlab === idMethod
                })


                if (tmp){
                    // console.log(JSON.stringify(tmp))
                    return tmp.data
                } else{
                    return  {
                        "id_methodlab": "",
                        "data": []
                    }
                }




            },


            closeSelectBactWithPickData(payload){
                // console.log(JSON.stringify(payload))
                this.data_orga.idbact = payload.id
                this.isShowSelectBact = false
            },

            closeSelectBact(){
                this.isShowSelectBact = false
            },
            selectBact(){
                this.isShowSelectBact = true
            },







            closeSelectDrugWithData(payload){
                payload.forEach(dat=>{

                    this.data_orga.drugs.push(
                                                {
                                                "iddrug": dat.id,
                                                "drug_name": dat.name,
                                                "idresult": null,
                                                "result_name": null,
                                                "idmic_prefix": null,
                                                "mic_prefix": null,
                                                "mic_val": null,
                                                "remark": "",
                                                "sort_id": "",
                                                "iddrug_uuid":   genUUID(12)
                                                }
                                             )
                })

                this.isShowSelectDrug = false
            },
            closeSelectDrug(){
                this.isShowSelectDrug = false
            },
            addDrugInEachIDbact_uuid(){
                this.isShowSelectDrug = true


            },
            deleteEachBactID(){
                // console.log(this.data_orga.idbact_uuid)
                this.$emit('delete_idbact_uuid',this.data_orga.idbact_uuid)
            },
            deleteDrugItem(iddrug_uuid){
                const tmpDrug = this.data_orga.drugs.find(dat=>{
                    return dat.iddrug_uuid == iddrug_uuid
                })

                     const tmpDrugName = tmpDrug.drug_name
                     const memberIndex =  this.data_orga.drugs.indexOf(tmpDrug)
                     this.data_orga.drugs.splice(memberIndex,1)

                     this.$buefy.toast.open({
                        duration: 1500,
                        message: `Item drug  <i class="is-size-3 has-text-weight-bold "> ${tmpDrugName} </i>   has been <b>delete</b>`,
                        position: 'is-bottom',
                        type: 'is-primary'
                     })
                    //  this.$buefy.dialog.confirm({
                    //     title: 'Deleting Drug?',
                    //     message: 'Are you sure you want to <b>delete</b> drug? This action cannot be undone.',
                    //     confirmText: 'Delete Drug',
                    //     type: 'is-danger',
                    //     hasIcon: true,
                    //     onConfirm: () =>  this.data_orga.drugs.splice(memberIndex,1)
                    // })


            },
            clearContent(iddrug,kind){



                if(kind === 'idbact'){
                    this.data_orga.idbact  = null
                    return
                }


                if(kind === 'bact_remark'){
                    this.data_orga.bact_remark  = ''
                    return
                }

                // find drug
                const tmpDrug = this.data_orga.drugs.find(dat=>{
                    return dat.iddrug == iddrug
                })
                // console.log(tmpDrug)

                if(tmpDrug){
                    // kind === 'mic'  or  'result'
                    if(kind === 'result'){

                        tmpDrug.idresult = null
                        tmpDrug.result_name = null
                    }
                    if(kind === 'mic'){
                        tmpDrug.idmic_prefix = null
                        tmpDrug.mic_prefix = null
                        tmpDrug.mic_val = null
                    }

                }
            },



        },
        data(){
            return {
                // bacterialModel : null,
                isShowSelectDrug : false,
                draggingRow: null,
                draggingRowIndex: null ,


                //
                isShowSelectBact : false,



                //
                // methodLab : [ {"id":1 , "descp" :"ตรวจหาเชื้อแบคทีเรียทั่วไป"},
                //               {"id":2 , "descp" :"ตรวจหาเชื้อแบคทีเรียด้วยกล้องจุลทรรศน์ Gram stain"},
                //               {"id":3 , "descp" :"ตรวจหาเชื้อแบคทีเรียด้วยกล้องจุลทรรศน์ Dark field (spirochete)"},
                //              ] ,
                //
                // resultOfMethodLab : [{"id":1 , "id_methodlab": 1 , "data": ["+1","+2","+3"]} ,
                //     {"id":2 , "id_methodlab": 2 , "data": ["Gram +","Gram -"]} ,
                //     {"id":2 , "id_methodlab": 3 , "data": ["Neg","Pos"]}
                // ],



                // methodLabSelected : null,
                // resultOfMethodLabSelected : null,
                // remark_methodLab : null,



                // allResultSelected : null,





            }
        },
        watch:{
           "data_orga.id_lab_method" : {
               immediate : true,
               handler: function () {
                   // if(val === ""){
                   //     // clear
                       this.data_orga.id_lab_method_result = ""
                       this.data_orga.remark_method = ""
                   // }
               }
           },

        }
    }
</script>

<style scoped>
    /*.button-clear:hover{*/
    /*    opacity: 100%; !important;*/
    /*}*/
    /*.button-clear{*/
    /*    opacity: 0%;!important;*/
    /*}*/
</style>